import { Link } from "react-router-dom";
import { Button, Typography, Box, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function NotFound() {
  return (
    <Paper sx={{ p: 4, textAlign: "center", mt: 6 }}>
      <Box sx={{ mb: 2 }}>
        <SearchIcon color="primary" sx={{ fontSize: 48 }} />
      </Box>
      <Typography variant="h5" gutterBottom>
        Stranica nije mogla biti pronadjena!
      </Typography>
      <Box sx={{ mt: 3 }}>
        <Button variant="contained" color="primary" component={Link} to="/home">
          Vrati se na početnu stranicu
        </Button>
      </Box>
    </Paper>
  );
}
